import { default as Marty, ApplicationContainer } from "marty";
import React from "react";
import App from "./config/app";
import fastclick from "fastclick";

//Prevents 300 ms click delay on mobile
fastclick.attach(document.body);

//Instantiate the app
let app = new App();

//Add these to the window for use by the React and Marty dev tools.
window.React = React;
window.Marty = Marty;
window.app = app;
window.app.router = app.router;

//Fetch the app state from the DOM and bootstrap it into the client app.
app.rehydrate();

//Run the app
app.router.run((Handler, state) => {
    React.render((
        <ApplicationContainer app={app}>
            <Handler {...state.params} />
        </ApplicationContainer>
    ), document.getElementById("app"));
});



/** WEBPACK FOOTER **
 ** ./app/client.js
 **/